var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3723",
    "data-name": "Caminho 3723",
    d: "M206-245a7,7,0,0,0,7,7,7,7,0,0,0,7-7,7,7,0,0,0-7-7A7,7,0,0,0,206-245Zm11.575,3.875-8.45-8.45a6,6,0,0,1,8.081.369A6,6,0,0,1,217.575-241.125Zm-8.455.705a6,6,0,0,1-.7-8.445l8.445,8.445a6,6,0,0,1-7.745,0Z",
    fill: "#e8061d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3722",
    "data-name": "Caminho 3722",
    d: "M205-237H317v-16H205Z",
    fill: "#e8061d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "block",
    transform: "translate(-202 -527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3621",
    "data-name": "Grupo 3621",
    transform: "translate(-4 779)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3620",
    "data-name": "Grupo 3620",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3721",
    "data-name": "Caminho 3721",
    d: "M201-257h24v24H201Z",
    fill: "#e8061d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.34adc8c323a5370cef115eb402fc7246.svg";
export { ForwardRef as ReactComponent };